import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: { name: 'combine_ab_c' },
    },
    {
      path: '/combine_ab_c',
      name: 'combine_ab_c',
      component: () => import('@/pages/combine_ab_c/combine.vue'),
    },
  ],
})

export default router
